module.exports = __webpack_public_path__ + "img/platform-2-icon.52f4b52d.svg";